import React, { lazy, Suspense } from 'react';
import { Router, Switch, Route, Redirect, withRouter } from 'react-router-dom';

import Transitions from '../../transitions';
import Favourites from '../Routes/Favourites';
import { useStateValue } from '../../context/state';

const Home = lazy(() => import('../Routes/Home'));
const Search = lazy(() => import('../Routes/Search'));
const Station = lazy(() => import('../Routes/Station'));
const Nearby = lazy(() => import('../Routes/Nearby'));
const Info = lazy(() => import('../Routes/Info'));
const Impressum = lazy(() => import('../Routes/Impressum'));
const Error = lazy(() => import('../Routes/Error'));

const Container = (props) => {
  const { history } = props;
  const [{ editFavoritesMode }, _setShowMenuButton] = useStateValue();

  const setShowMenuButton = (aValue) => {
    _setShowMenuButton({
      type: 'setShowMenuButton',
      newState: aValue
    });
  }

  return (
    <div className="container-wrapper">
      <Router history={history}>
        <Route render={({ location }) => (
          <Transitions pageKey={location.key} {...location.state}>
            <Suspense fallback={<div>Loading...</div>}>
              <Switch location={location}>
                <Route exact={true} path='/' render={(props) => <Home {...props} />} />
                <Route path='/search' render={(props) => <Search {...props} />} />
                <Route path='/favourites' render={(props) => <Favourites {...props} setShowMenuButton={setShowMenuButton} editFavoritesMode={editFavoritesMode} />} />
                <Route exact={true} path='/station/:id/:pf' render={(props) => <Station {...props} />} />
                <Route path='/station/:id/:pf/:pt' render={(props) => <Station {...props} />} />
                <Route path='/station/info' render={(props) => <Info {...props} />} />
                <Route path='/error' render={(props) => <Error {...props} />} />
                <Route path='/impressum' render={(props) => <Impressum {...props} />} />
                <Route path='/nearby/station/:id' render={(props) => <Nearby {...props} />} />
                <Redirect from='*' to='/' />
              </Switch>
            </Suspense>
          </Transitions>
        )}
        />
      </Router>
    </div>
  );
}

export default withRouter(Container);